var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTerrace(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6922 1.40058L0.595784 0.102231C0.347517 0.0775059 0.126431 0.258908 0.101847 0.507062C0.0772346 0.755244 0.258495 0.976415 0.506677 1.001L13.196 2.25899V3.06362H0.551245C0.301849 3.06362 0.0996452 3.26583 0.0996452 3.51522C0.0996452 3.76462 0.301849 3.96682 0.551245 3.96682H10.7405V13.1964H7.55104V9.72472H9.41388C9.66331 9.72472 9.86548 9.52251 9.86548 9.27312C9.86548 9.02372 9.66331 8.82152 9.41388 8.82152H4.78499C4.53559 8.82152 4.33339 9.02372 4.33339 9.27312C4.33339 9.52251 4.53559 9.72472 4.78499 9.72472H6.64784V13.1964H5.18014V10.9666C5.18014 10.7172 4.97794 10.515 4.72854 10.515H2.49877V7.86187C2.49877 7.61247 2.29656 7.41027 2.04717 7.41027C1.79777 7.41027 1.59557 7.61247 1.59557 7.86187V13.1964H0.551245C0.301849 13.1964 0.0996452 13.3986 0.0996452 13.648C0.0996452 13.8974 0.301849 14.0996 0.551245 14.0996H12.2928C12.5423 14.0996 12.7444 13.8974 12.7444 13.648C12.7444 13.3986 12.5423 13.1964 12.2928 13.1964H11.6437V3.96682H13.6476C13.8971 3.96682 14.0992 3.76462 14.0992 3.51522V1.84995C14.0992 1.61783 13.9232 1.42347 13.6922 1.40058ZM2.49877 11.4182H4.27694V13.1964H2.49877V11.4182Z",
    fill: "#01152E",
    stroke: "#01152E",
    strokeWidth: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6912 13.1986C13.5807 13.1869 13.4598 13.2189 13.3604 13.2988C13.0478 13.5572 13.2074 14.0591 13.6025 14.0973C14.1994 14.1544 14.2823 13.2552 13.6912 13.1986Z",
    fill: "#01152E",
    stroke: "#01152E",
    strokeWidth: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTerrace);
export default __webpack_public_path__ + "static/media/terrace.b49724ba2b708b3185e9e7b7ee8be701.svg";
export { ForwardRef as ReactComponent };